var __getOwnPropNames = Object.getOwnPropertyNames;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};

export { __commonJS };
//# sourceMappingURL=chunk-556IGTOR.js.map
//# sourceMappingURL=chunk-556IGTOR.js.map